export default {
  VENEZUELA: "VE",
  PERU: "PE",
  COLOMBIA: "CO"
};
